import React from "react";
import img1 from "../../images/manufacturerBenefits/service (1).svg";
import img2 from "../../images/manufacturerBenefits/organic.svg";
import img3 from "../../images/manufacturerBenefits/search.svg";
import { Row, Col } from "react-bootstrap";
import BenefitsCard from "../BenefitsCard/BenefitsCard";
import { Container } from "@material-ui/core";
export default function PPNAPPFeatures() {
  const benefits = [
    {
      img: img2,
      title: "Report Services",
      bodycopy: "Report Services facilitate users in creating and managing reports concerning plant and products, ensuring comprehensive monitoring and analysis.",
    },
    {
      img: img3,
      title: "Analytics Services",
      bodycopy:
        "Analytics Services provide users with powerful tools to easily monitor plants and products, enabling tracking of product manufacturing status and location for enhanced oversight and management.        ",
    },


      {
        img: img1,
        title: "Generic Services",
        bodycopy:
        "Generic Services offer users the ability to access farm details and market prices for assets, providing valuable information for decision-making and planning purposes."
      },
  ];
  return (
    <div className="main-wrapper">
      <Container className="subSectionWrapper ">
        <h2 className="text-center container-title mb-4">Features</h2>
        <Row>
          {benefits.map((e,index) => {
            return (
              <Col md={4} key={index} className="d-flex">
                <BenefitsCard
                  src={e.img}
                  title={e.title}
                  bodycopy={e.bodycopy}
                />
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
  );
}
